import { Card } from "react-bootstrap";
import { useTheme } from "../../themes/ThemeContext";
import Sparkline from "../common/Sparkline";

const PlayerNumberCard = (props) => {
  const { number, title, sparklineData } = props;
  const { theme } = useTheme();

  const startColor = theme.colors.secondary["secondary-dark5"];
  const endColor = theme.colors.background["background-dark3"];
  const headerColor = theme.colors.surface["surface-light2"];
  const numberColor =
    theme.colors.secondaryvariant1["secondaryvariant1-light1"];

  return (
    <Card
      className="p-0 mb-3"
      style={{
        background: `linear-gradient(to right, ${startColor}, ${endColor})`,
        border: "none"
      }}
    >
      <Card.Header
        style={{
          fontSize: "22px",
          color: headerColor,
          textTransform: "uppercase"
        }}
        className="fw-bolder"
      >
        {title}
      </Card.Header>
      <Card.Body>
        <Card.Text style={{ color: numberColor }} className="fs-1 fw-bold">
          {number}
        </Card.Text>
        {sparklineData && (
          <Sparkline data={sparklineData} color={numberColor} height={48} />
        )}
      </Card.Body>
    </Card>
  );
};

export default PlayerNumberCard;
